import { useState, useCallback, useMemo } from 'react';
import EfImg from '@elem/ui/ef-img';
import EditorImg from 'lowcode/components/EditorImg';
import EfSpec from '@elem/ui/ef-spec';
import styled from './index.module.scss';
import CheckedIcon from './Icon';
import useConfig from './useConfig';
import Emarsys from '@/components/MembersDay/FY2025/Sections/Emarsys';
import getLocal from '@/app/utils/getLocal';
import gtm from '@/utils/gtm';
import { useLang } from '@/i18n';
import { getPrivacyPolicy } from '@/utils/common';

const source = 'Y25_ECO_CREDITS_DAY';
const SUPPORTED_LOCALES = ['us', 'jp', 'au', 'kr', 'za'];

const Subscribe = () => {
    const { locale } = getLocal();
    const { contactListId, fields } = useConfig(locale);
    const { t } = useLang('membersday.subscribe');
    const [checked, setChecked] = useState(SUPPORTED_LOCALES.includes(locale) ? true : false);

    // GTM 事件处理
    const handleGTMEvent = useCallback(
        (status: 'success' | 'fail') => {
            gtm.push({
                event: 'uaEvent',
                event_name: 'activity_submit',
                button_name: t('btnText'),
                status,
                tag: 'Agree',
            });
        },
        [t],
    );

    const successCallBack = useCallback(() => {
        try {
            handleGTMEvent('success');
        } catch (e) {
            console.error(e);
        }
    }, [handleGTMEvent]);

    const errorCallback = useCallback(() => {
        handleGTMEvent('fail');
    }, [handleGTMEvent]);

    const { privacyLink, termsLink } = useMemo(() => {
        const defaultPrivacyUrl = getPrivacyPolicy(locale);
        const defaultTermsUrl = `https://${locale}.ecoflow.com/policies/terms-of-service`;

        return {
            privacyLink: locale === 'jp' ? 'https://account.ecoflow.com/agreement/ja-jp/PrivacyPolicy.html' : defaultPrivacyUrl,
            termsLink: locale === 'jp' ? 'https://account.ecoflow.com/agreement/ja-jp/TermsOfUse.html' : defaultTermsUrl,
        };
    }, [locale]);

    return (
        <div className={styled.Subscribe}>
            <div className="subscribe_content">
                <EfImg
                    pc="https://websiteoss.ecoflow.com/upload/image/1741750691480/subscribe_bg.jpg"
                    pad="https://websiteoss.ecoflow.com/upload/image/1742799156440/subscribe_pad.jpg"
                    h5="https://websiteoss.ecoflow.com/upload/image/1742527505844/subscribe_bg_h5.jpg"
                    alt={t('title')}
                />
                <div className="subscribe_box">
                    <h5 className="subscribe_title">{t('title')}</h5>
                    <div className="email-box">
                        <Emarsys
                            contactListId={contactListId}
                            fields={fields}
                            source={source}
                            submitText={t('btnText')}
                            placeholder={t('placeholder')}
                            successCallback={successCallBack}
                            errorCallback={errorCallback}
                            checked={checked}
                        />
                        <p className="protocol">
                            <span
                                className={`check ${checked ? 'checked' : ''}`}
                                onClick={() => setChecked((prev) => !prev)}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        e.preventDefault();
                                        setChecked((prev) => !prev);
                                    }
                                }}
                            >
                                {checked && <CheckedIcon />}
                            </span>
                            {t.rich('protocol', {
                                line1: (text: string) => (
                                    <a className="link" href={privacyLink} target="_blank" rel="noreferrer">
                                        {text}
                                    </a>
                                ),
                                line2: (text: string) => (
                                    <a className="link" href={termsLink} target="_blank" rel="noreferrer">
                                        {text}
                                    </a>
                                ),
                            })}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Subscribe;
